export default __webpack_public_path__ + "static/media/close-icon.c4fcdbb5.svg";